module.exports = __webpack_public_path__ + "347515ee86053e4f1cbd59d3c7ea06e4.pdf";